<template>
  <div style="background: transparent; padding: 0px" :class="modalTheme">
    <!-- <h4>Pat Task Comm FORM</h4> -->
    <!-- modalTheme{{ modalTheme }} -->
    <!-- <h3>rowId {{rowId}}</h3> -->
    <!-- <br> -->
    <!-- taskData {{taskData}} -->

    <b-row style="background: transparent; padding: 0px" :class="modalTheme">
      <!-- <b-col>
        <h5 style="background-color:black;color:cyan;">PATIENT TASK COMMENT FORM</h5>
      </b-col>-->

      <b-card title sub-title="Card myWorkCard2" header no-body style="padding: 0px 0px 0px 0px; height: 225px" header-tag="header">
        <template #header>
          <b-row class="justify-content-sm-start" style="height: 20px; padding: 0px">
            <b-col cols="10" style="padding: 0px 0px 0px 00px" class="d-flex justify-content-start" v-b-toggle.PatientWork>
              <h5 class style="padding-left: 20px">Task Comments:</h5>
            </b-col>
          </b-row>
        </template>

        <b-card-body :class="modalTheme">
          <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
            <div class="task-comment">
              <div class="d-flex flex-column">
                <textarea
                  v-model="currentComment"
                  class="patient-comment-textarea"
                  v-on:keydown.enter="onSubmit()"
                  placeholder="New Comment (2000 character limit)"
                  name="patientCommentTextArea"
                  id
                  cols="10"
                  rows="10"
                ></textarea>
              </div>
              <div class="d-flex mt-3">
                <div class="ml-auto patient-note-buttons">
                  <b-button :class="modalTheme" class="mr-3" type="submit" variant="primary-green">Submit</b-button>
                  <b-button :class="modalTheme" type="reset" variant="primary-green">Cancel</b-button>
                </div>
              </div>
            </div>
          </b-form>
          <b-collapse id="PatientWork" class="mt-2">
            <b-row class="text-center">
              <b-col cols="9" class="d-flex justify-content-end">
                <h5 style="padding-top: 10.5px">STuff goes HERE</h5>
              </b-col>
              <b-col cols="3" class="d-flex justify-content-end"> little stuff </b-col>
            </b-row>
          </b-collapse>
        </b-card-body>
      </b-card>

      <b-col style="background: transparent; max-height: 20vh; overflow: auto">
        <!-- taskData {{this.taskData.data}} -->
        <!-- <h4>taskData taskComments {{this.taskData.data.taskComments.length}}</h4> -->
        <!-- <h3 v-show="AreIdsShown" style="background-color:darkgreen;color:lime;">TasksCommentsContainer</h3> -->
        <h6 v-show="AreIdsShown" style="background-color: darkblue; color: yellow">
          currentPatientTaskComments Qty:
          {{ patientStore.currentPatientTaskComments.length }}
        </h6>
        <h6 v-show="AreIdsShown" style="background-color: blue; color: yellow">
          INC..taskComms Qty:
          {{ taskData.data.taskComments.length }}
        </h6>
        <h6 v-show="AreIdsShown" style="background-color: black; color: lime">INC..rowId {{ rowId }}</h6>

        <TaskComment
          v-for="comment in patientStore.currentPatientTaskComments"
          :comment="comment"
          :key="comment.commentId"
          class="comment-box"
          @edit-comment="onEditComment"
          @reply-comment="onEditComment"
          @delete-comment="onEditComment"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
// * STORE
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

import { usePatientStore } from "@/stores/patientStore";

import TaskComment from "@/modules/Patient/TaskComment.vue";

import { toast } from "vue3-toastify";

// & PROPS
const props = defineProps({
  taskData: {
    type: Object,
    default: () => {},
  },
  rowId: {
    type: String,
    default: () => {},
  },
});
// * EMITTER
const emit = defineEmits(["post-comment", "close-modal"]);

const patientStore = usePatientStore();

const modalTheme = computed(() => userStore.bModalTheme);

const AreIdsShown = ref(false);

const currentComment = ref(null);

function onSubmit() {
// console.log("TASKS COMMENTS FORM - SUBMIT");

// console.log("currentComment");
// console.dir(currentComment.value);

  // toast.success("Hello");
  // toast.info("World");
  // toast.error("Error");

  if (currentComment.value.length >= 4000) {
    toast.error("The maximum size of the comment is 4000 characters");

    return;
  }
  if (currentComment.value.length < 5) {
    toast.error("A comment should be at least 5 characters");
    return;
  }

// console.log("EMITTING from onSubmit ");
  // console.log('  													 patientId ', this.patientId)
  // this.$emit('post-comment', {
  // 	text: this.currentComment,
  // 	patientId: this.patientId,
  // })

// console.log("     	new V3 EMITTER		NEW EMITTER                    post-comment");

// console.log("  REBUILDing   CONT for POST COMMEnt");
  emit("post-comment", {
    usrSelectRowId: patientStore.currentSelectedPatientTask.id,
    text: currentComment.value,
    patientId: patientStore.currentPatientId,
  });

  // // console.log('EMITTING from onSubmit ')
  // // console.log('  	 	<>>>>>>>>>>>>>>>>>>>>>>>												 incoming iD ',id)
  // this.$emit('post-comment2', {				text: this.currentComment,				patientId: id,			})

  onReset();
}

function onReset() {
  currentComment.value = "";
  // this.$emit('close-modal')

// console.log("         	new V3 EMITTER		NEW EMITTER close-modal");
  emit("close-modal");
}
function onEditComment(resp) {
// console.log("	TASKSCommentsContainer  >  onEditComment          EDIT  REPLY and DELETE ALL GOTO HERE !!");
// console.log("RESPONSE");
// console.dir(resp);

  //todo RESP.payload === this.$store.state['comments'].papaComments

// console.log("	STORE SETTER			ON EDIT COMMENT: >> 	resp  	setCurrentPatientTasksComments		(resp.payload ");
  patientStore.setCurrentPatientTasksComments(resp.payload);

  // console.log('		STORE GET < currentPatientTaskComments  2 localPaComments')

  // this.localPaComments = patientStore.currentPatientTaskComments;
  // // console.log(' localPaComments : ')
  // console.dir(this.localPaComments);

  // // console.log(' SORTING ........  currentPatientTaskComments   createdDate ')
  // this.localPaComments.sort((a, b) => a.createdDate > b.createdDate);
  // console.dir(this.localPaComments);
  // //this.localPaComments.sort((a, b) => (a.dueDate > b.dueDate ? 1 : -1))
  // //	this.localPaComments = this.$store.state['comments'].papaComments
}

onMounted(() => {
// console.log("onMounted() :       PATIENT Task Comments FORM  >>>>");
// console.log(" prop   rowId ");
  //   console.log('props : ')
  // console.log(props);
  // console.log(props.taskData);
// console.log(props.rowId);
});
</script>

<style lang="scss" scoped>
.comments-list {
  list-style: none;

  .comment {
    // background: #77c1b2;
    padding: 0.5rem 0;
    word-wrap: break-word;
    white-space: pre-wrap; // this is so we don't have to use pre
  }

  .comment-text {
    font: inherit;
    font-size: 1.1em;
  }

  .comment-date {
    font-size: 0.9em;
    font-weight: 800;
    padding-bottom: 0.5rem;
    color: #123456; // $primary-dark-blue;
  }
}

.top-row {
  //  color: #eef8ef;

  .top-left-info {
    font-weight: bold;
    font-size: large;
  }

  a {
    text-decoration: underline;
    margin-left: 1em;
    //  color: #eef8ef;
  }
}

.text-center,
.card-body {
  // background: primary; // primary-green;
  padding: 0px 0px 0px 0px;
  max-width: 450px;
  min-width: 350px;
}

.testClass {
  background: darkgreen; // $inspinia-green;
  padding: 0px 0px 3px 0px;
}

.tasks-comments {
  //  background: #77c1b2;
  border-radius: 5px;
  width: 50%;
  //  color: #eef8ef;
  box-shadow: 5px 10px 12px #888888;
}

.existing-comment {
  background: #353535; // $primary-light-gray;
  margin: 2rem;
  padding: 1rem;
  border-radius: 1rem;
  width: 80%;
  overflow-y: auto;
  max-height: 50vh;
}

.task-comment,
.patient-comment {
  padding-top: 1rem;
  width: 90%;
  margin: 0 auto;

  &-textarea {
    display: block;
    height: 6rem;
    // margin: 0 auto;
    // width: 80%;
    //  background: #dcf1de;
    //  color: #123486;
    font-weight: bolder;
  }
}

.task-form {
  margin-top: 1rem;
  height: 8rem;
}

.btn-primary-green {
  border: none;
  text-decoration: none;
  color: #fcfefc;
  background-color: #b0c1b2;
}
.btn-primary-green:hover {
  background-color: #caeacd;
  color: #123486;
  border-radius: 0px 0px 0px 0px;
}

.btn-sm,
.btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1;
  border-radius: 0.2rem;
  background: #eef8ef;
}

.bg-dark-greenSummary {
  background-color: purple; // #9aa99b !important;
  color: yellowgreen !important;
  /* 30% */
}

.card-header {
  padding: 5px 0px 0px 0px;
  font-size: 18pt;
  color: yellow;
}

.text-light {
  color: #eef8ef !important;
}

.card-body {
  padding: 0% !important;
  //  background-color: #849185 !important;
  /* 20% */
}
</style>
